















































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
import GlobalMixins from "@/global.mixin";
import {importExportApi} from "../../../services/api/importexport.api";
import { deviceTypesApi } from "../../../services/api/deviceTypes.api";
import LoadingPopup from "@/components/LoadingPopup.vue";

@Component({
  mixins: [GlobalMixins],
  components: { LoadingPopup }
})
export default class DeviceTypes extends Vue {
  @State("deviceTypes") deviceTypesState: any;

  @Action("getDeviceTypes") getDeviceTypes: any;
  @Action("saveDeviceType") saveDeviceType: any;
  @Action("deleteDeviceType") deleteDeviceType: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  formValid = false;

  editingDialog = false;
  isNewDeviceType = false;
  defaultItem = {
    deviceTypeId: 0,
    name: "",
    description: "",
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;

  // Upload related properties
  uploadDialog = false;
  uploadDialogTitle = "";
  uploadDialogText = "";
  loading = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "name",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("deviceTypes-rowsPerPage") ?
                        parseInt(this.$cookies.get("deviceTypes-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
    { text: "#", value: "deviceTypeId", width: "1%", align: "left", sortable: true},
    { text: this.$t("DEVICE_TYPES_TABLE_HEADER_NAME"), value: "name", width: "1%", align: "left", sortable: true },
    { text: this.$t("DEVICE_TYPES_TABLE_HEADER_DESCRIPTION"), value: "description", width: "1%", align: "left", sortable: true },
    { text: this.$t("TABLE_ACTIONS"), value: "", sortable: false,  }
  ];
  }
  created() {
    // -
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  updatePagination(pagination) {
    this.$cookies.set("deviceTypes-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getDeviceTypes(page);
  }

  save() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {

      this.saveDeviceType({
        data: JSON.stringify(this.editedItem),
        index: this.editedIndex
      })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
    }
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    if (this.$refs.form) {
      // this.$refs.form.resetValidation();
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }

  editItem(item) {
    this.isNewDeviceType = false;
    this.editedIndex = this.deviceTypesState.deviceTypes.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.deviceTypesState.deviceTypes.indexOf(item);

    if (confirm(this.$t("DEVICE_TYPE_DELETE_CONFIRM") as string)) {
      this.deleteDeviceType({ id: item.deviceTypeId, index });
    }
  }

  // Download methods
  downloadDeviceTypesData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
    };
    importExportApi.downloadDeviceTypeExport(page, "eszkoz-tipus-export.xlsx");
  }

  // Upload methods
  onPickFile() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  selectFile(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    this.loading = true;

    deviceTypesApi.upload(file)
      .then(res => {
        if (res.data.status === 1) {
          // success
          this.uploadDialogTitle = "Sikeres betöltés!";
          this.uploadDialogText = res.data.msg;
        } else if (res.data.status === 3) {
          // validation errors
          this.uploadDialogTitle = "Hiba van az adatokban!";
          this.uploadDialogText = res.data.errors.join("<br>");
        } else {
          this.uploadDialogTitle = "Error";
          this.uploadDialogText = res.data.msg || "Unknown error occurred";
        }
        this.loading = false;
        this.uploadDialog = true;
        // Refresh the data after successful upload
        if (res.data.status === 1) {
          this.updatePagination(this.pagination);
        }
      })
      .catch(error => {
        this.loading = false;
        this.uploadDialogTitle = "Unexpected Response!";
        this.uploadDialogText = JSON.stringify(error);
        this.uploadDialog = true;
        console.error("Upload failed:", error);
      });

    // Clear the file input so the same file can be selected again
    event.target.value = "";
  }
}
